module.exports = __webpack_public_path__ + "static/media/prix-de-west-2021.02c58f2d.jpg";